import { clsx } from "clsx";
import { HTMLAttributes } from "react";
import { TableActions } from "./TableActions";
import { TableAddButton } from "./TableAddButton";
import { TableBody } from "./TableBody";
import { TableCell } from "./TableCell";
import { TableColumn } from "./TableColumn";
import { TableContent } from "./TableContent";
import { TableFilter } from "./TableFilter";
import { TableHeader } from "./TableHeader";
import { TableNoContent } from "./TableNoContent";
import { TablePagination } from "./TablePagination";
import { TableRow } from "./TableRow";
import { TableSearchBar } from "./TableSearchBar";
import { TableSelectionCell } from "./TableSelectionCell";
import { TableSort } from "./TableSort";

export interface TableRootProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const Table = ({ children, className, ...props }: TableRootProps) => (
  <div className={clsx("flex flex-col justify-between w-full gap-8", className)} {...props}>
    {children}
  </div>
);

Table.SearchBar = TableSearchBar;
Table.AddButton = TableAddButton;
Table.ActionsColumn = () => (
  <TableColumn>
    <span className="sr-only">Ações</span>
  </TableColumn>
);
Table.SelectionColumn = () => (
  <TableColumn className="pr-0">
    <span className="sr-only">Selecionar</span>
  </TableColumn>
);
Table.Content = TableContent;
Table.Header = TableHeader;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Column = TableColumn;
Table.Cell = TableCell;
Table.SelectionCell = TableSelectionCell;
Table.Pagination = TablePagination;
Table.Actions = TableActions;
Table.NoContent = TableNoContent;
Table.Filter = TableFilter;
Table.Sort = TableSort;
